export const FETCH_PURCHASE_RETURN_REQUEST = "FETCH_PURCHASE_RETURN_REQUEST";
export const FETCH_PURCHASE_RETURN_SUCCESS = "FETCH_PURCHASE_RETURN_SUCCESS";
export const FETCH_PURCHASE_RETURN_FAIL = "FETCH_PURCHASE_RETURN_FAIL";

export const ADD_PURCHASE_RETURN_REQUEST = "ADD_PURCHASE_RETURN_REQUEST";
export const ADD_PURCHASE_RETURN_SUCCESS = "ADD_PURCHASE_RETURN_SUCCESS";
export const ADD_PURCHASE_RETURN_FAIL = "ADD_PURCHASE_RETURN_FAIL";
